import { render, staticRenderFns } from "./Understand.vue?vue&type=template&id=1a3cbd6e&scoped=true&"
import script from "./Understand.vue?vue&type=script&lang=js&"
export * from "./Understand.vue?vue&type=script&lang=js&"
import style0 from "./Understand.vue?vue&type=style&index=0&id=1a3cbd6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3cbd6e",
  null
  
)

export default component.exports